import * as React from 'react';
import { Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';

interface Props {
  children?: React.ReactNode;
  uploadWarning?: boolean;
}

const UploadIntro = (props: Props) => {
  const { children, uploadWarning } = props;

  return (
    <Alert as="section" status={uploadWarning ? 'warning' : 'info'} mb={6}>
      <AlertIcon />

      <AlertDescription>{children}</AlertDescription>
    </Alert>
  );
};

export default UploadIntro;
